import { createFileRoute } from '@tanstack/react-router'
import { SettingsLayout } from '_/features/settings/ui/components/settings-layout'

export const Route = createFileRoute('/_authenticated/settings')({
	staticData: { title: 'settings_title' },
	component: SettingsLayout,
})
